function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m368 5.01v93.99c0 2.761 2.239 5 5 5h93.99c4.454 0 6.685-5.386 3.536-8.536l-93.99-93.99c-3.15-3.149-8.536-.919-8.536 3.536z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m344 152c-13.255 0-24-10.745-24-24v-128h-226c-29.775 0-54 24.224-54 54v404c0 29.776 24.225 54 54 54h324c29.775 0 54-24.224 54-54v-306zm-24 128h-40v40c0 13.255-10.745 24-24 24s-24-10.745-24-24v-40h-40c-13.255 0-24-10.745-24-24s10.745-24 24-24h40v-40c0-13.255 10.745-24 24-24s24 10.745 24 24v40h40c13.255 0 24 10.745 24 24s-10.745 24-24 24z"
});

var SvgAddDocument = function SvgAddDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-document.6e4469ed.svg";
export { ForwardRef as ReactComponent };